// extracted by mini-css-extract-plugin
export default {"question":"AuditingQuestion_question__KJyfi","error":"AuditingQuestion_error__4iszc"};